import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaCardField extends HTMLAhaCardFieldElement {}

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-card-field',
  styleUrl: 'aha-card-field.css',
  shadow: true,
})
export class AhaCardField {
  @Element() host!: HTMLAhaCardFieldElement;

  /**
   * Whether to prevent wrapping in the contents.
   */
  @Prop({ reflect: true }) nowrap: boolean = false;

  render() {
    return (
      <Host>
        <slot name="icon"></slot>
        <slot></slot>
      </Host>
    );
  }
}
